export default __webpack_public_path__ + "static/media/orglogo.93de84d7.png";